import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    highlightedTags: {
        keywords: null,
        locations: null,
        people: null
    }
};

const tagSlice = createSlice({
    name: 'tags',
    initialState,
    reducers: {
        setHighlightedTag(state, action) {
            const { category, tag } = action.payload;
            // Toggle: if the same tag is already selected, unselect it
            if (state.highlightedTags[category] === tag) {
                state.highlightedTags[category] = null;
            } else {
                state.highlightedTags[category] = tag;
            }
        },
        resetHighlightedTags(state) {
            state.highlightedTags = { keywords: null, locations: null, people: null };
        }
    }
});

export const { setHighlightedTag, resetHighlightedTags } = tagSlice.actions;
export default tagSlice.reducer;
